import { AlertService } from './../../../services/alert/alert.service';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { ContentService } from 'src/app/services/content/content.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-page-terms-conditions',
  templateUrl: './page-terms-conditions.page.html',
  styleUrls: ['./page-terms-conditions.page.scss'],
})
export class PageTermsConditionsPage implements OnInit {
  @Input() isModal = false;
  @Input() heigtTextPorcent = "100%";
  @Input() isInnerPage = false;

  @Input() id: any =  '63f8be7b648765001b7dfe00';
  data: any;
  file: any;
  isStrapi: boolean = true;
  constructor(public languageService: LanguagesService,
    private contentService: ContentService,
    private alertService: AlertService,
    private modalController: ModalController,
    private remoteConfig: RemoteConfigService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.remoteConfig.getIsStrapi().subscribe((res) => {
      this.isStrapi = res;
    });
    this.contentService.getTermsAndPolices("terminos_y_condiciones", this.id).then((data: any) => {
      if((data.length > 0)){
        this.data = data && data[0] ? data[0] : [];
        this.data.content = this.data.Content ? this.data.Content : this.data.content;
        if(this.data.content[0].Description){
          this.data.content.push({
            type: "description",
            value: this.data.content[0].Description
          })
        }
        this.file = this.data.content;
      } else {
        if(this.isModal){
          this.alertService.presentAlert('No tienes terminos asociados')
            this.back()
        }
      }
    });
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  get getTextIUTermsConditions() {
    return this.languageService.textsIU.page_terms_conditions;
  }

  back(){
    this.modalController.dismiss(null, null, "modal-terms-conditions");
  }
}
